import { SET_MODE } from './types';

export const toggleMode = (data) => (dispatch) => {
  localStorage.setItem('dark', JSON.parse(data));
  dispatch({ type: SET_MODE, payload: JSON.parse(data) });
};
